import { unbindParameterName } from "@octopusdeploy/octopus-server-client";
import * as React from "react";
import { RoleChip } from "~/components/Chips/index";
import { isBoundRegex } from "~/components/form/BoundField/isBound";
import ParseHelper from "../../utils/ParseHelper/ParseHelper";
import TargetList from "./TargetList";
interface RolesProps {
    rolesAsCSV: string;
}
class RolesList extends TargetList<string> {
}
const Roles: React.FC<RolesProps> = (props) => {
    const roles = ParseHelper.parseCSV(props.rolesAsCSV);
    if (roles.length === 1 && isBoundRegex(roles[0])) {
        const boundParameterName = roles[0];
        return (<span>
                tags specified from the parameter <strong>{unbindParameterName(boundParameterName)}</strong>
            </span>);
    }
    return (<span>
            {roles.length === 1 ? "the tag" : "the tags"} <RolesList targets={roles} renderTarget={(role) => <RoleChip key={role} role={role}/>}/>
        </span>);
};
Roles.displayName = "Roles"
Roles.displayName = "Roles";
export default Roles;
